/* unplugin-vue-components disabled */import script from "./indexConnection.vue?vue&type=script&setup=true&lang=js"
export * from "./indexConnection.vue?vue&type=script&setup=true&lang=js"

import "./indexConnection.vue?vue&type=style&index=0&id=72362e4d&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72362e4d"]])

export default __exports__